<!--<h3>{{ 'dataTransformations.searchTransformations' | translate }}</h3>-->
<div class="row fields-group">
    <div class="col">
        <label for="search-transformation-field" class="d-block list-title">{{ "Field's value type" | translate }}</label>
        <select id="search-transformation-field" class="d-flex w-100 form-control" [(ngModel)]="typeTransformation" (change)="typeUpdate()">
            <option value="">Value of the field</option>
            <option value="getUrlMetadata">URL of the field</option>
            <option value="getPublicUrl">Document download link</option>
        </select>
    </div>
</div>
